import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { RiunioneGiudiziEditComponent } from './riunione-giudizi-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [riunione-giudizi-mod-edit]',
  templateUrl: 'riunione-giudizi-mod-edit.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class RiunioneGiudiziModEdit {
  @Output() onReturn: EventEmitter<FascicoloFull> = new EventEmitter<FascicoloFull>();
  @ViewChild('formRiunioneGiudiziEdit') formRiunioneGiudizi: RiunioneGiudiziEditComponent;

  inizializza(fascicolo: FascicoloFull, fascicoliRiuniti: FascicoloFull[]) {
    this.formRiunioneGiudizi.inizializza(fascicolo, fascicoliRiuniti);
    openModal('riunioneGiudiziModEdit');
  }

  createForm() {
    this.formRiunioneGiudizi.createForm();
  }

  manageModal(fascicoloFull: FascicoloFull) {
      closeModal('riunioneGiudiziModEdit');
      this.onReturn.emit(fascicoloFull);
  }
}
